import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function PassengerSidePhoto() {
  return <PhotoLayout {...photoLayoutConfig['passengerside']} />;
}
